export const EMA_TASK_LIST_REQUEST = 'EMA_TASK_LIST_REQUEST'
export const EMA_TASK_LIST_SUCCESS = 'EMA_TASK_LIST_SUCCESS'
export const EMA_TASK_LIST_FAIL = 'EMA_TASK_LIST_FAIL'
export const EMA_TASK_LIST_RESET = 'EMA_TASK_LIST_RESET'
